import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { SummaryDataItemModel } from '../models/summary-data-item-model';

@Injectable({
  providedIn: 'root'
})
export class PageHelperService {
  public selectedCompanyId: string;
  public pageTitle: string;
  public loading: Subject<boolean> = new Subject<boolean>();;
  public summaryData:  Subject<SummaryDataItemModel[]> = new Subject<SummaryDataItemModel[]>();
  public selectedCompanySubscription: Subject<string> = new Subject<string>();
  public pageTitleSubscription: Subject<string> = new Subject<string>();

  setSelectedCompanyId(companyId: string): void {
    this.selectedCompanyId = companyId;
    this.selectedCompanySubscription.next(companyId);
  }

  setPageTitle(title: string): void {
    this.pageTitle = title;
    this.pageTitleSubscription.next(title);
  }
}
